module.exports = __webpack_public_path__ + "assets/media/leo-face.33bef6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/TreeringTestimonial/leo-face.png
// module id = 1990
// module chunks = 0